module.exports = __webpack_public_path__ + "static/media/Fashion.711967f3.png";